module.exports = __webpack_public_path__ + "img/fairJoinScusess.72876dc8.jpg";